// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"1bb880b1","143":"afcf8962","144":"f1ff6cc3","494":"ca7c81db","533":"d1e3c96e","651":"c0eaaaab","690":"aca96f0a","852":"7732dfa9","940":"6c4a5d90"}[chunkId] + ".chunk.js";
};